module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/service/Frame@2x(4).png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Fservice%2FFrame%402x(4).png
// module id = toOJ
// module chunks = 93